import axios from "@/plugins/axios.js"

const actions = {
  fetchOrders({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/orders?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDERS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchOrder({ commit }, orderId) {
    return new Promise((resolve, reject) => {
      axios.get(`/orders/${orderId}/show`)
        .then((response) => {
          if(response.data.success){
            commit('SET_ORDER', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
}

const getters = {
   
}


const mutations = {
  SET_ORDERS(state, data) {
    state.pageData = data
  },
  SET_ORDER(state, order){
  	state.order = order
  },
  UPDATE_ORDER(state, item){
    const dataIndex = state.pageData.data.findIndex((i) => i.id == item.id);
    if(dataIndex > -1){
      Object.assign(state.pageData.data[dataIndex], item);
    }
  },
  DELETE_ORDER(state, orderId){
    const itemIndex = state.pageData.data.findIndex((item) => item.id == orderId)
    state.pageData.data.splice(itemIndex, 1)
  },

  /**************** THIS IS FOR MESSAGES********************/
  ADD_MESSAGE(state, message){
    state.order.messages.push(message)
  },
  UPDATE_MESSAGE(state, message){
    const dataIndex = state.order.messages.findIndex((a) => a.id == message.id);
    if(dataIndex > -1){
      Object.assign(state.order.messages[dataIndex], message);
    }
  },
  DELETE_MESSAGE(state, messageId){
    const itemIndex = state.order.messages.findIndex((item) => item.id == messageId)
    state.order.messages.splice(itemIndex, 1)
  },
}

const state = {
  pageData: {
    data: []
  },
  order: {},
}


export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

